import React from "react";
import { Redirect } from "react-router-dom";
import { ReportForm } from "./component";
import { isSuperUser } from "../../../utils/is-superuser";

export default class ReportParcela extends React.Component {
  render() {
    const isAdmin = isSuperUser();

    if (!isAdmin) {
      return <Redirect to="/" />;
    }

    return (
      <React.Fragment>
        <ReportForm />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Relatorios/Parcela/index.js